import { initMarmosetViewer } from './marmoset'

let currentIndex = 0
let carousel = null
let slides = null
let prevButton = null
let nextButton = null

function updateNavState() {
  if (!prevButton || !nextButton) return

  prevButton.disabled = currentIndex === 0
  nextButton.disabled = currentIndex === slides.length - 1
}

function scrollToSlide(index) {
  if (!carousel || !slides || index < 0 || index >= slides.length) return

  currentIndex = index
  const slide = slides[index]
  slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })

  updateNavState()

  // Load Marmoset viewer if this slide is 3D and not yet loaded
  if (slide.dataset.mediaType === '3d') {
    const container = slide.querySelector('.embed__marmoset-container')
    if (container && !container.dataset.loaded) {
      initMarmosetViewer(container)
    }
  }
}

function handlePrevClick() {
  if (currentIndex > 0) {
    scrollToSlide(currentIndex - 1)
  }
}

function handleNextClick() {
  if (currentIndex < slides.length - 1) {
    scrollToSlide(currentIndex + 1)
  }
}

export function initCarousel() {
  carousel = document.querySelector('.embed__carousel')
  slides = document.querySelectorAll('.embed__slide')
  prevButton = document.querySelector('.embed__nav--prev')
  nextButton = document.querySelector('.embed__nav--next')

  if (!carousel) return

  // Load first slide's 3D viewer immediately (autoplay)
  const firstSlide = slides[0]
  if (firstSlide && firstSlide.dataset.mediaType === '3d') {
    const container = firstSlide.querySelector('.embed__marmoset-container')
    if (container && !container.dataset.loaded) {
      initMarmosetViewer(container)
    }
  }

  // Only set up navigation if there are multiple slides
  if (slides.length <= 1) return

  if (prevButton) {
    prevButton.addEventListener('click', handlePrevClick)
  }

  if (nextButton) {
    nextButton.addEventListener('click', handleNextClick)
  }

  updateNavState()
}
